import React, { useContext } from 'react';
import { FaReceipt } from "react-icons/fa";
import { FaPersonWalkingLuggage } from "react-icons/fa6";
import { BsPersonCircle } from 'react-icons/bs';
import STC from '../../../../../STCLibrary/STCFactory/STCFactory';
import './PortalHeaderHamburgerMenu.css'; 
import { useNavigate, useParams } from 'react-router-dom';
import { LogoutAPIs } from '../../../../../API/LogoutAPIs/LogoutAPIs';
import ApiResponseHandler from '../../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';
import NotificationContext from '../../../../../STCLibrary/NotificationSystem/NotificationContext';

export default function PortalHeaderHamburgerMenu({ setShowMenu, isParent }) {
    
    const notificationCtx = useContext(NotificationContext);
    const navigate = useNavigate();
    const routeParams = useParams();

    const handleClick = (path) => {
        setShowMenu(false);
        navigate(path)
    }

    const handleLogOut = () => {
        if (window.confirm('Are you sure you want to logout?')) {
            LogoutAPIs.PostLogout()
            .then((response) => {
                if(response.status === 200 && !response.data.error){
                    navigate('/');
                }
            })
            .catch((err) => {
                ApiResponseHandler(err.response, notificationCtx, navigate)
            })
            navigate('/');   
        }
    };


    return (
        <div className="hamburger-menu">
            <div className="menu-items">
                {isParent && 
                <STC.Button onClick={() => handleClick('/' + routeParams.userID + '/passengers')}>
                    <FaPersonWalkingLuggage /> Passengers
                </STC.Button>}
                
                {isParent && 
                <STC.Button onClick={() => handleClick('/' + routeParams.userID + '/payment-history')}>
                    <FaReceipt /> Payment History
                </STC.Button>}

                {isParent && 
                <STC.Button onClick={() => handleClick('/' + routeParams.userID + '/my-account')}>
                    <BsPersonCircle /> My Account
                </STC.Button>     }
          
                <STC.Button onClick={() => handleLogOut()}>
                    Log Out
                </STC.Button>  
                
                <STC.Button onClick={() => setShowMenu(false)}>
                    Close
                </STC.Button>
            </div>  
        </div>
    );
}
